import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "rings" }
const _hoisted_2 = { class: "ring-outer" }
const _hoisted_3 = { class: "ring-inner" }
const _hoisted_4 = { class: "label" }

import { computed } from 'vue'

import ProgressRing from '../components/ProgressRing.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'TimerRings',
  props: {
    innerVal: {},
    outerVal: {},
    isWork: { type: Boolean },
    label: {}
  },
  setup(__props: any) {

const props = __props

const innerColor = computed(() => '#FFFFFFAA') // props.isWork ? '#FF3344' : '#7799FF')

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(ProgressRing, {
        size: 320,
        width: 25,
        value: _ctx.outerVal,
        label: _ctx.label,
        labelColor: innerColor.value,
        color: "#FFFFFFAA"
      }, null, 8, ["value", "label", "labelColor"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(ProgressRing, {
        size: 250,
        width: 25,
        value: _ctx.innerVal,
        color: innerColor.value
      }, null, 8, ["value", "color"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})